<template lang="pug">
form(@submit.prevent="generate")
  modal(active, title="Gerar carnê", @close="$router.back()")
    div(slot="modal-body")
      load-manager.scrollable(:errors="errors", :loading="loadingDebitos")
        .container.grid-lg(v-if="debitos.length > 0")
          .h6.text-error Total: {{ total | currency("R$") }}
          .columns
            .column.col-6.col-sm-12.my-2(v-for="debito in debitos")
              row(:debito="debito")
        .empty.mx-2(v-else)
          .empty-icon
            i.icon.icon-search.icon-3x
          p.empty-title.h5 Nada para exibir
          p.empty-subtitle Nenhum registro encontrado
    div(slot="modal-footer")
      button.btn.btn-primary(:class="{loading: loadingCarne}" v-if="showButton")
        | Gerar boleto
</template>

<script>
import { defaultStoreImports } from "@/mixins/show";
import api from "@/api/carnes";
import Row from "./RowDebito";
import parseErrors from "@/lib/errors/parseErrors";
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: { carnes: defaultStoreImports },
  data() {
    return { loadingDebitos: false, errors: [], loadingCarne: false };
  },
  components: { Row },
  computed: {
    debitos() {
      return this.current ? this.current.rows : [];
    },
    showButton() {
      return this.debitos.length > 0 && !this.loadingDebitos;
    },
    total() {
      let total = 0;
      this.debitos.forEach((i) => (total += i.valor));
      return total;
    },
  },
  methods: {
    async generate() {
      try {
        this.loadingCarne = true;
        const { url } = await api.create(this.$route.params.id, this.current);
        window.open(url, "_blank");
      } catch (e) {
        toastErrors(e);
      } finally {
        this.loadingCarne = false;
      }
    },
  },
  async created() {
    try {
      this.loadingDebitos = true;
      await this.fetchOne(this.$route.params.id);
    } catch (e) {
      this.errors = parseErrors(e);
    } finally {
      this.loadingDebitos = false;
    }
  },
};
</script>
